import * as React from "react";

import "./selective-agent-select.scss";

import {chain}            from "@Common/utils/fs";
import {SearchableSelect} from "@Common/ui-components/searchable-select/searchable-select";
import {xdQAAttribute}    from "../analytics-layout";

const AGENT_FIELDS_SEARCHABLE = [
    "agentNameFirst",
    "agentNameLast"
]

export const SelectiveAgentSelect = ({agents, idAgent, setLeadsSelected, setFilters, isInternalUser=false}) => {

    return (
        <div  className="selective-agent-select-dznts83">
            {
                SearchableSelect({
                    list: agents,
                    disabled: !Array.isArray(agents) || agents.length < 1,
                    getLabel: (agent) => chain(
                        agent.fullName,
                        (name) => {
                            return (
                                <span
                                    title={name}
                                    {...xdQAAttribute('dropdown_item', `Agent ${name}`)}
                                >
                                    {name}
                                </span>
                            )
                        }
                    ),
                    placeholder: "Please select an agent",
                    onSelect: (agent) => {
                        setFilters([])
                        setLeadsSelected([])
                        idAgent.onChange(agent.idAgent)
                    },
                    isSelected: (agent) => agent.idAgent === idAgent.value,
                    getSublabel: (agent) => {
                        if(!isInternalUser) {
                            return
                        }
                        return (
                            <div {...xdQAAttribute('dropdown_item', `Agent ${agent.idAgent}`)}>
                                {`| Internal ID: ${agent.idAgent}`}
                            </div>
                        )
                    },
                    mapSearchAsItemFilter: (search) => {
                        const searchLowercase = search.toLowerCase()
                        return (agent) =>
                               (isInternalUser && agent.idAgent.includes(searchLowercase)) ||
                                AGENT_FIELDS_SEARCHABLE.some(
                                    field => agent[field]?.toLowerCase().includes(searchLowercase)
                                )
                    },
                    xdQaName: "Agent",
                })
            }
        </div>
    )
}